import * as yup from 'yup';

export interface IHsCodeLookupFormValues {
	// The product search term. Named `searchTerm` (not `name`) so browsers don't autofill the
	// user's personal name; it is sent to the lookup API as `name`.
	searchTerm: string;
	// The hand-typed HS code, only used (and only required) in manual mode.
	hsCode: string;
	// True while the user is typing the HS code by hand instead of picking a search result.
	manualEntry: boolean;
}

export const hsCodeLookupInitialValues: IHsCodeLookupFormValues = {
	searchTerm: '',
	hsCode: '',
	manualEntry: false,
};

// hsCode is only required in manual mode, so its requiredness is driven off `manualEntry`.
export const hsCodeLookupSchema = yup.object({
	searchTerm: yup.string().required('step-export.hsCodeLookup.required'),
	hsCode: yup.string().when('manualEntry', {
		is: true,
		then: schema =>
			schema
				.required('step-export.hsCodeLookup.required')
				.matches(/^\d{6}$/, 'step-export.hsCodeLookup.hsCodeInvalid'),
		otherwise: schema => schema.notRequired(),
	}),
	manualEntry: yup.boolean(),
});
